import React from "react";
import Header from "../Components/Header";
import Bannerslider from "../Components/Bannerslider";
import Bottomslider from "../Components/Bottomslider";
import Bestseller from "../Components/Bestseller";
import Specialoffer from "../Components/Specialoffer";
import Trendingsproduct from "../Components/Trendingsproduct";
import Shopbycategory from "../Components/Shopbycategory";
import Footer from "../Components/Footer";
import Slidertwo from "../Components/Slidertwo";
import Whatpeoplesay from "../Components/Whatpeoplesay";
import { coma1, coma2 } from "../Constant/Index";

function Home() {
  return (
    <>
      <Header />
      <Bannerslider />
      <Bottomslider />
      <Bestseller />
      <Specialoffer />
      <Trendingsproduct />
      <Shopbycategory />
      <Bestseller />
      {/* Insta Seciton  */}
      <section className="insta-slider-sec position-relative">
        <div className="best-seller-heading insta-heading">
          <span className="font-chalottre natural-heading insta-head">
            natural
          </span>
          <h2 className="body-color ">FOLLOW US ON INSTAGRAM</h2>
        </div>
        <Slidertwo />
      </section>
      {/* =================== */}

      {/* What People Section  */}
      <section className="what-people-sec">
        <div className="what-img1">
          <img className="img-fluid" src={coma1} alt="coma" />
        </div>
        <Whatpeoplesay />
        <div className="what-img2">
          <img className="img-fluid" src={coma2} alt="coma" />
        </div>
      </section>

      {/* =============== */}
      <Footer />
    </>
  );
}

export default Home;
